import { render, staticRenderFns } from "./StorageLayouts.vue?vue&type=template&id=f5cdbb38&scoped=true&"
import script from "./StorageLayouts.vue?vue&type=script&lang=js&"
export * from "./StorageLayouts.vue?vue&type=script&lang=js&"
import style0 from "./StorageLayouts.vue?vue&type=style&index=0&id=f5cdbb38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cdbb38",
  null
  
)

export default component.exports